var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.558,
    height: 12,
    viewBox: "0 0 12.558 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "linkedin",
    d: "M0,6.394a1.305,1.305,0,0,1,.424-1A1.556,1.556,0,0,1,1.527,5a1.51,1.51,0,0,1,1.079.388A1.367,1.367,0,0,1,3.03,6.43a1.276,1.276,0,0,1-.412.97A1.559,1.559,0,0,1,1.5,7.8H1.491A1.483,1.483,0,0,1,.412,7.4,1.343,1.343,0,0,1,0,6.394ZM.158,17V8.9H2.848V17Zm4.182,0H7.03V12.479a1.578,1.578,0,0,1,.612-1.352,1.317,1.317,0,0,1,.867-.285q1.358,0,1.358,1.83V17h2.691V12.358a3.9,3.9,0,0,0-.848-2.721,2.894,2.894,0,0,0-2.242-.927A2.751,2.751,0,0,0,7.03,10.055v.024H7.018l.012-.024V8.9H4.339q.024.388.024,2.412T4.339,17Z",
    transform: "translate(0 -5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.21224ed12120dbd91b4cb7a81a987d22.svg";
export { ForwardRef as ReactComponent };